module.exports = __webpack_public_path__ + "static/media/dummy-paragraph.7910b537.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/dummy-paragraph.png
// module id = 513
// module chunks = 0